import React from 'react';

import { Box, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

export default function LandFilter(props: {
    landFilter: Record<string, any>;
    setLandFilter: Function;
}): React.ReactElement {
    return (
        <Box>
            <InputGroup>
                <InputLeftElement
                    pointerEvents='none'
                    children={<SearchIcon color='gray.300' />}
                />
                <Input
                    type='text'
                    placeholder='Buscar por nombre'
                    value={props.landFilter?.identifier || ''}
                    onChange={(e) =>
                        props.setLandFilter({
                            ...props.landFilter,
                            identifier: e.target.value
                        })
                    }
                />
            </InputGroup>
        </Box>
    );
}
